export default () => ({
  dedicatedDomain: {},
  dedicatedDomainCount: {},
});
